import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{on:{"click":function($event){_vm.open = true}}},[_vm._v("Open Side Quests")]),_c('SideQuestsDrawer',{attrs:{"quests":_vm.quests},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }